import type { MarketingError } from '../api/errors';
import type { DemoScenario } from './scenario';

/**
 * O que uma página precisa saber de uma lista que vem da API, sem depender
 * do objeto inteiro do React Query: em que fase está, qual foi o erro e como
 * tentar de novo. Os itens em si ficam ao lado (`campaigns`, `templates`...).
 */
export type ResourcePhase = 'loading' | 'error' | 'ready';

export interface ResourceState {
  phase: ResourcePhase;
  error: MarketingError | null;
  refetch: () => void;
}

export const READY_STATE: ResourceState = { phase: 'ready', error: null, refetch: () => undefined };

interface QueryLike {
  isPending: boolean;
  isError: boolean;
  error: unknown;
  refetch: () => unknown;
}

export function resourceState(query: QueryLike, toError: (error: unknown) => MarketingError): ResourceState {
  if (query.isError) return { phase: 'error', error: toError(query.error), refetch: () => void query.refetch() };
  if (query.isPending) return { phase: 'loading', error: null, refetch: () => void query.refetch() };
  return { phase: 'ready', error: null, refetch: () => void query.refetch() };
}

const SCENARIO_ERROR: MarketingError = {
  kind: 'unknown',
  status: 500,
  message: 'Erro simulado pelo cenário de demonstração.',
  blocks: [],
  code: null,
};

/**
 * Só no modo mock (`VITE_USE_MOCKS=true`): `?cenario=` força a fase da lista
 * para o time inspecionar carregamento, erro e vazio sem mexer no servidor.
 */
export function applyScenario<T>(items: T[], state: ResourceState, scenario: DemoScenario): { items: T[]; state: ResourceState } {
  if (scenario === 'carregando') return { items: [], state: { ...state, phase: 'loading', error: null } };
  if (scenario === 'erro') return { items: [], state: { ...state, phase: 'error', error: SCENARIO_ERROR } };
  if (scenario === 'vazio') return { items: [], state: { ...state, phase: 'ready', error: null } };
  return { items, state };
}
